import { get, handleErrors, post, put, deleteRequest } from "./requests";
import { URL_BASE } from "./constants";
import { loadCompanies } from "../redux/actions/companyActions";
import { Store } from "../redux/store";

async function getAllCompanies() {
    const url = `${URL_BASE}/companies`;
    const companiesPayload = await get(url);
    Store.dispatch(loadCompanies(companiesPayload.data));
    return companiesPayload.data;
}

async function addCompany(name, responsibleName, email, city, stateCode) {
    const company = {
        name,
        responsibleName,
        email,
        city,
        stateCode
    };
    const url = `${URL_BASE}/companies`;

    await post(url, company, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCompanies();
}


async function updateCompany(id, name, responsibleName, email, city, stateCode) {
    const company = {
        id,
        name,
        responsibleName,
        email,
        city,
        stateCode
    };
    const url = `${URL_BASE}/companies`;

    await put(url, company, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCompanies();
}

async function deleteCompany(id) {
    const url = `${URL_BASE}/companies/${id}`;
    await deleteRequest(url, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCompanies();
}

export default {
    getAllCompanies,
    addCompany,
    deleteCompany,
    updateCompany
};